module.exports = __webpack_public_path__ + "img/zww.a8f3fefa.png";